import dayjs from 'dayjs';

import type {CoachOrClientTaskApiModel} from '../../../api/task/types';
import type {Nullable} from '../../utility-types';

import {anyOf} from '../../conditionalUtils';
import {datetimeObjToISOString} from '../../datetime';
import {isDefined} from '../../typecheck';
import {isTaskOverdue} from './isTaskOverdue';

export const isTaskCanBeDone = (task?: Nullable<CoachOrClientTaskApiModel>) =>
  isDefined(task)
    ? task.status !== 'frozen' &&
      anyOf([
        dayjs().isSame(dayjs(datetimeObjToISOString(task.start_date)), 'day'),
        isTaskOverdue(task),
      ])
    : false;
